module.exports = __webpack_public_path__ + "static/city_icon_10-fea46a2af58db8d7be30f24340b30c8d.png";